import {
  styled, rem
} from 'config/stitches.config'

import SimpleLink from '@/UI/Link'

export const StyledNewsPreview = styled('article', {
  borderTop: '1px solid $black',
  paddingY: rem(24),
  '@md': { paddingY: rem(32), },
  '&:last-child': { paddingBottom: 0 },
})

export const StyledNewsPreviewContainer = styled(SimpleLink, {
  textDecoration: 'none',
  width: '100%',
  flexDirection: 'column',
  rowGap: rem(48),

  '.NewsPreview_image': {
    width: '100%',
    aspectRatio: '343 / 240',

    'img': {
      size: '100%',
      objectFit: 'cover',
      objectPosition: 'center center'
    },

    '@md': {
      aspectRatio: '432 / 140',
      flexBasis: '50%',
    }
  },
  '@md': { flexDirection: 'row', }
})

export const StyledNewsPreviewDateRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: rem(16),
  marginBottom: '$1',
})

export const StyledNewsPreviewCategoryBadge = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: '#dadada',
  color: '$black',
  borderRadius: rem(32),
  paddingX: rem(16),
  paddingY: rem(8),
  fontSize: '$p5-mobile',
  '@md': { fontSize: '$p5' },
})

export const StyledNewsPreviewContent = styled('div', {
  textAlign: 'left',
  width: '100%',
  '> span': { marginBottom: '$1', },
  'strong': {
    fontSize: '$news-title-mobile',
    '@md': { fontSize: '$news-title', }
  },

  '@md': {
    flexBasis: '50%',
    flexShrink: 0,
    paddingRight: rem(80)
  }
})

